import axios from '@/libs/api.request'
var qs = require('qs')
    // 获取列表数据
export const fetchTableList = (params) => {
    let data = qs.stringify(params)

    return axios.request({
        url: '/role-management/list',
        data,
        method: 'post'
    })
};
// 添加
export const setAdd = (params) => {
    let data = qs.stringify(params)
    return axios.request({
        url: '/role-management/insert',
        data,
        method: 'post'
    })
};
// 修改
export const setUpdate = (params) => {
    let data = qs.stringify(params)
    return axios.request({
        url: '/role-management/update',
        data,
        method: 'post'
    })
};
// 获取详情

export const fetchedit = (params) => {
    let data = qs.stringify(params)
    return axios.request({
        url: '/role-management/info',
        data,
        method: 'post'
    })
};
// 改变状态
export const changeStatus = (params) => {
    let data = qs.stringify(params)
    return axios.request({
        url: '/role-management/status',
        data,
        method: 'post'
    })
};
// 获取权限列表
export const fetchPermissionList = (params) => {
    let data = qs.stringify(params)
    return axios.request({
        url: '/role-management/menu-list',
        data,
        method: 'post'
    })
};
// 修改权限
export const changePermissionList = (params) => {
    let data = qs.stringify(params)
    return axios.request({
        url: '/role-management/update-menu',
        data,
        method: 'post'
    })
}